import Num from '@flipster/utils/num';

import type { SizeInputMode } from '../../position/adjust-order/popover';

/**
 * amend 요청의 사이즈 파라미터 조립 (순수).
 * - quantity → qty / usdt → amount / margin → amount = margin × leverage
 * - 사이즈 미변경(빈 값)은 아무 필드도 보내지 않는다.
 */
export function buildSizeParams(
  sizeMode: SizeInputMode,
  sizeValue: string | undefined,
  leverage: number,
): { qty?: string; amount?: string } {
  if (sizeValue == null || sizeValue === '') return {};
  if (sizeMode === 'quantity') return { qty: sizeValue };
  if (sizeMode === 'usdt') return { amount: sizeValue };
  // margin mode → convert collateral to position size (amount = margin * leverage)
  const amount = Num(sizeValue).multipliedBy(leverage).toString();
  return { amount };
}
